import type { ReactNode } from 'react';
import { Badge } from './primitives';

// Fase 24B: badge de estado unificado con semantica de color + SIEMPRE texto (no depende solo del
// color). Reemplaza gradualmente las familias ad-hoc (form-badge/stock-badge/...). El dominio decide
// la variante; no se infiere por nombre.
// P-075: dibuja el `Badge` del rediseño: una sola familia de etiquetas, no una tercera.
export type StatusVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export function StatusBadge({ variant = 'neutral', children }: { variant?: StatusVariant; children: ReactNode }) {
  return <Badge tone={variant}>{children}</Badge>;
}
